export type Extractor<TDatum, TOutput> = ((fn: TDatum) => TOutput) | keyof TDatum;

export function applyExtractor<TDatum, TOutput>(datum: TDatum, extractor: Extractor<TDatum, TOutput>): TOutput {
    if (typeof extractor === 'function') {
        return extractor(datum);
    }
    // @ts-ignore
    return datum[extractor];
}
